import React, { useState, useEffect } from "react";
import SoftwareProjects from "./softwareComponents/softwareProjects";
import SoftwareCertificates from "./softwareComponents/softwareCertificates";
import Footer from "../../components/Footer";

import { Button } from "react-bootstrap";

function Software() {
  const storedValue = localStorage.getItem("softwarePage");
  const [projectsOrCertificates, setPOC] = useState(
    storedValue ? storedValue === "true" : true
  );

  function setProject() {
    setPOC(true);
    localStorage.setItem("softwarePage", true);
  }

  function setCertificate() {
    localStorage.setItem("softwarePage", false);
    setPOC(false);
  }

  const softwareLinks = [
    {
      title: "Travellow",
      caption:
        "An application that provides a forum for users to post their ideal travel locations.",
      url: "https://travellow.herokuapp.com/",
      image: "travellow",
      description:
        "This site is hosted on a free service, may take up to 15 seconds to load",
    },
    {
      title: "Movies R Us",
      caption:
        "An application that allows the user to search for movies and read their details.",
      url: "https://node-movie-database.herokuapp.com/",
      image: "moviesRUs",
      description:
        "This site is hosted on a free service, may take up to 15 seconds to load",
    },
    {
      title: "Todoer",
      caption:
        "A todo application that allows the users to add tasks and mark them as complete.",
      url: "https://todoer-react-app.herokuapp.com/",
      image: "todoer",
      description:
        "This site is hosted on a free service, may take up to 15 seconds to load",
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "300px",
        }}
      >
        <div className="pl-5 pr-5 pt-5 mt-5">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <h2 className="section-heading text-uppercase">Software</h2>
          </span>
          <p>
            This page allows you to see projects that I have worked on and
            certificates I have gained on my software journey
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "500px !important",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={setProject}
              variant={projectsOrCertificates ? "success" : "outline-success"}
              style={{ width: "300px" }}
            >
              Projects
            </Button>
            <Button
              onClick={setCertificate}
              variant={!projectsOrCertificates ? "danger" : "outline-danger"}
              style={{ width: "300px" }}
            >
              Experiences
            </Button>
          </div>
        </div>
      </div>

      {projectsOrCertificates ? (
        <SoftwareProjects softwareLinks={softwareLinks} />
      ) : (
        <SoftwareCertificates />
      )}
      <Footer />
    </div>
  );
}

export default Software;
